import React, { createContext, useContext, useState } from 'react';

const DetailsContext = createContext();

export const useDetails = () => {
    return useContext(DetailsContext);
};

export const DetailsProvider = ({ children }) => {
    const [details, setDetails] = useState(null);

    return (
        <DetailsContext.Provider value={{ details, setDetails }}>
            {children}
        </DetailsContext.Provider>
    );
};
